import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import './assets/styles/main.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// ถ้ามี token ค้างอยู่ (refresh หน้า) โหลด role/permission กลับมาก่อน mount
// route guard ใน router/index.ts จัดการ redirect ไป /login เองถ้าไม่มี token
const auth = useAuthStore()
auth.loadProfile().finally(() => {
  app.mount('#app')
})
